import React from 'react';
import { EMVATReportGeneric } from "./EMVATReportGeneric"
import { Table, Card, Button, Select, Typography, DatePicker, Tag, Modal, Space, Divider, Input, Tabs } from "antd";
import { visualize } from '../api/api'
import { StandardVATReportType } from '../utils/constants';
import moment from "moment";

export const EMSelect = ({ value, onChange }) => {

    const [em, setEm] = React.useState([])

    const load = async () => {
        const { data: { rows = [] } } = await visualize('em_name')
        setEm(rows.map(({ id, full_name }) => ({ id, full_name })))
    }

    React.useEffect(() => {
        load();
    }, [])

    return <React.Fragment>
        <Select showSearch optionFilterProp={'children'} placeholder="Select an EM" style={{ width: 400 }} key={em} onChange={onChange} value={value}>
            {
                em.map(({ id, full_name }) => <Select.Option key={id} value={id}>{full_name}</Select.Option>)
            }
        </Select>
    </React.Fragment>
}


export const EMVATReportView = (props) => {

    const [em, setEm] = React.useState()
    const [report, setReport] = React.useState()


    const tabCallback = async (key) => {
        console.log(em, key)
        setReport(key)
    }


    return <React.Fragment>
        <Card
            title={<EMSelect value={em} onChange={e => {setEm(e); setReport(StandardVATReportType.B2B)}} />}
        >
            <Tabs key={em} defaultActiveKey="B2B" onChange={tabCallback}>
                {em&&report&&<Tabs.TabPane tab="B2B Sales" key={StandardVATReportType.B2B} >
                    {em && report && <EMVATReportGeneric em={em} report_type={report} />}
                </Tabs.TabPane>}
                {em&&report&&<Tabs.TabPane tab="Domestic" key={StandardVATReportType.DOMESTIC} >
                    {em && report && <EMVATReportGeneric em={em} report_type={report} />}
                </Tabs.TabPane>}
                {em&&report&&<Tabs.TabPane tab="EI Facilitation" key={StandardVATReportType.EI_FACILITATION} >
                    {em && report && <EMVATReportGeneric em={em} report_type={report} />}
                </Tabs.TabPane>}
                {em&&report&&<Tabs.TabPane tab="FC REP" key={StandardVATReportType.FC_REP} >
                    {em && report && <EMVATReportGeneric em={em} report_type={report} />}
                </Tabs.TabPane>}
                {em&&report&&<Tabs.TabPane tab="OSS Union" key={StandardVATReportType.OSS_UNION} >
                    {em && report && <EMVATReportGeneric em={em} report_type={report} />}
                </Tabs.TabPane>}
                {em&&report&&<Tabs.TabPane tab="OSS Non-Union" key={StandardVATReportType.OSS_NON_UNION} >
                    {em && report && <EMVATReportGeneric em={em} report_type={report} />}
                </Tabs.TabPane>}
                {em&&report&&<Tabs.TabPane tab="OSS Import" key={StandardVATReportType.OSS_IMPORT} >
                    {em && report && <EMVATReportGeneric em={em} report_type={report} />}
                </Tabs.TabPane>}
                {em&&report&&<Tabs.TabPane tab="GIFTS" key={StandardVATReportType.GIFTCARD_SCHEME} >
                    {em && report && <EMVATReportGeneric em={em} report_type={report} />}
                </Tabs.TabPane>}
                {em&&report&&<Tabs.TabPane tab="Non-EU Country Import" key={StandardVATReportType.NON_EU_COUNTRY_IMPORT} >
                    {em && report && <EMVATReportGeneric em={em} report_type={report} />}
                </Tabs.TabPane>}
            </Tabs>

        </Card>

    </React.Fragment>
}